import { Injectable } from '@angular/core';

const LOCAL = 'local';
const SANDBOX = 'sandbox';
const PRODUCTION = 'production';

@Injectable()
export class EnvironmentService {
    constructor() {}

    environment = '';
    environments = {
        local: LOCAL,
        sandbox: SANDBOX,
        production: PRODUCTION,
    };

    initialize() {
        const hostName = window.location.hostname;
        if (hostName.includes('localhost')) {
            this.environment = this.environments.local;
        } else if (hostName.includes('sandbox')) {
            this.environment = this.environments.sandbox;
            return;
        } else {
            this.environment = this.environments.production;
        }

        console.log(`Environment: ${this.environment}`);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/environment.service.ts